<div class="flex-column gap-4 animated fadeIn f-1-0">
	<div class="flex-row gap-2 align-items-center">
		<input type="text" class="m-0 f-1-0" style="height: 32px; max-width: 400px;"
			   (keyup.enter)="resolveDomain();"
			   placeholder="Domain to check"
			   [(ngModel)]="domainTxt">
		<btn-c [isDisabled]="!domainTxt || resolveDomainInProcess" (action)="resolveDomain();">
			Check
		</btn-c>
	</div>

	<trustifi-table-c
		class="trustifi-table" style="flex: 1 0; z-index: 5; max-width: 700px;"
		*ngIf="resolveDomainResult"
		[list]="resolveDomainResult"
		[headers]="[
			{text:'Priority', sortKey:'priority'},
			{text:'Hostname', sortKey:'exchange'},
		]"
		[cellsPrototype]="[
			{textKey: 'priority'},
			{textKey: 'exchange'},
		]"
		[options]="{
			itemsNameSingular: 'record',
			defaultSortKey: 'priority',
		}"
		>
	</trustifi-table-c>


	<loader class="opacity-75 align-self-center" height="80" width="80" *ngIf="resolveDomainInProcess"></loader>

</div>
